import React, { PureComponent } from 'react';
import { CancelToken } from 'axios';
import { Helmet } from 'react-helmet';
import { WidgetMapaAramet } from '../../widgets/MapaAramet/WidgetMapaAramet';
import API from '../../utils/api';
import Loader from '../../partials/Loader/Loader';
import { translate } from '../../utils/translations';
import {
    buildLanguageConfig,
    consoleLogError,    
    formatDateByType,
} from '../../utils/utils';
import { parse } from 'qs';
import PropTypes from 'prop-types';
import { WIDGETS_PADDING } from '../../utils/globals';

class MapaAramet extends PureComponent {
    state = {
        config: buildLanguageConfig({}),        
        dataAramet: {},
        days: 0,
        widgetDate: '',
        widgetTime: '',
    };

    static propTypes = {
        preview: PropTypes.bool,
        color: PropTypes.string,
        language: PropTypes.string,
        target: PropTypes.string
    };

    render() {
        const { dataAramet, config, widgetDate, widgetTime } = this.state;
        if (config && dataAramet) {
            return (
                <div className="MapaAramet main-wrapper" style={WIDGETS_PADDING}>
                    <Helmet>
                        <title>{translate(config.language, 'aramet_title')}</title>
                    </Helmet>
                    <WidgetMapaAramet                    
                        dataAramet={dataAramet}
                        config={config}
                        preview={this.props.preview}
                        widgetDate={widgetDate}
                        widgetTime={widgetTime}
                    />
                </div>
            );
        }else{
            return <Loader language={config.language} />;
        }
    }

    componentDidMount() {
        this.feedWidget();        
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props !== prevProps) {
            this.feedWidget();            
        }        
    }

    componentWillUnmount() {
        this.cancelTokenSource.cancel(
            translate(this.state.config.language, 'cancelled_request')
        );
    }

    feedWidget = async () => {

        const search = this.props.location ? this.props.location.search : '';
                
        let config = {};

        // From Configurador form
        if (this.props.preview === true) {
            config = {
                color: this.props.color,
                language: this.props.language,
                target: this.props.target,
            };
        } else {
            // Or from Query String
            let querySearch = search
                .split('"')[0]
                .split('%22')[0]
                .split('%20')[0];
                
            config = buildLanguageConfig(
                parse(querySearch, {
                    ignoreQueryPrefix: true,
                })
            );
            
            //per temes d'accessibilitat canviem el tag de la pàgina pq sàpiga l'idioma
            document.documentElement.setAttribute('lang', config.language);
        }


        //agafem la data i hora actual i la formatejem per mostrar-la al widget en cas de que no hi hagi dades de la API
        const widgetDate = formatDateByType(new Date(), 'date');
        const widgetTime = formatDateByType(new Date(), 'time');

        this.setState({ config, widgetDate, widgetTime }); 
        this.getDataAramet();    
        
    };


    getDataAramet = async () => {

        this.cancelTokenSource = CancelToken.source();
        try {

            let dataAramet = await API.getAramet(this.cancelTokenSource.token);  
            this.setState({ dataAramet });

        } catch (e) {
            consoleLogError(e, this.state.config.language);
        }

    };

    
}

export default MapaAramet;



// WEBPACK FOOTER //
// ./src/containers/MapaAramet/MapaAramet.js